export default '/build/392a0019.svg'